import React, { useState } from "react";
import * as API from "../../utils/api.service";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import {TEXT_WITH_NOT_START_SPACE_VALIDATION, SWIT_SUCCESS, TOAST_ERROR,convertToBase64, NUMBER_VALIDATION } from '../../utils/common.service'
import Cookies from 'js-cookie'


export default function AddTournament() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [tournamentImageState, setTournamentImage] = useState(null);
  const [latterImageState, setLatterImageState] = useState(null);
  let userData = JSON.parse(Cookies.get('dataCA'));
  const [startDate, setStartDate] = useState("");
  const [ranges, setRanges] = useState([
    { start: "", end: "", points: "" },
    { start: "", end: "", points: "" },
    { start: "", end: "", points: "" },
    { start: "", end: "", points: "" },
    { start: "", end: "", points: "" },
  ]);

  const [valid, setValid] = useState(false);
  const [error, setError] = useState("");
  const [validRanges, setValidRanges] = useState([]);
  const [isActive, setIsActive] = useState("false");

  const handleImageChange = async (image, setImageState, fieldName) => {
    const imageSize = image.size / 1024; // convert size to KB
    if (imageSize > 3072) {
      TOAST_ERROR("Please select an image smaller than 3MB");
      return;
    }

    try {
      setValue(fieldName, image);
      const bufferImage = await convertToBase64(image);
      setImageState(bufferImage);
      clearErrors(fieldName);
    } catch (error) {
      TOAST_ERROR("An error occurred while processing the image");
    }
  };

  // Handle input change in range fields
  const handleChange = (index, field, value) => {
    const newRanges = [...ranges];
    newRanges[index][field] = value;
    setRanges(newRanges);
  };

  // Function to validate a specific range
  const validateRange = (range, previousEnd = null) => {
    const { start, end, points } = range;

    if (start === "" || end === "" || points === "") {
      setError(`Range fields cannot be empty.`);
      return false;
    }

    if (Number(start) >= Number(end)) {
      setError(`Range start must be less than the end for all ranges.`);
      return false;
    }

    if (previousEnd !== null && Number(start) <= Number(previousEnd)) {
      setError(`Range ${start} must be greater than the previous range's end.`);
      return false;
    }

    return true;
  };

  // Check and validate the ranges before submission
  let newValidRanges = [];
  const checkCompletion = () => {
    let previousEnd = null;

    for (let i = 0; i < ranges.length; i++) {
      // Only validate if at least one field is filled out for that range
      if (ranges[i].start || ranges[i].end || ranges[i].points) {
        if (validateRange(ranges[i], previousEnd)) {
          newValidRanges.push(ranges[i]);
          previousEnd = ranges[i].end;
        } else {
          setValid(false);
          return false; // Stop further validation if an invalid range is found
        }
      }
    }

    if (newValidRanges.length > 0) {
     // console.log("here ............................", newValidRanges);

      setValidRanges(newValidRanges);
      setValid(true);
      setError("");
      return true;
    } else {
      setValid(false);
      setError("Please fill at least one valid range properly.");
      return false;
    }
  };

  const onSubmit = async (submitData) => {
    // Run range validation before submission
    if (!checkCompletion()) {
      TOAST_ERROR("Please fill the ranges correctly before submitting.");
      return;
    }

    try {
      dispatch(setLoader(true));

      const {
        tournament_image,
        latter_image,
        tournament_title,
        ar_tournament_title,
        total_used_line,
        image_title,
        ar_image_title,
        wining_point,
        skip_point,
        description,
        ar_description,
        start_date,
        end_date,
        max_participation,
        required_point,
      } = submitData;

      let uploadedTournamentImage = tournament_image;
      let uploadedLatterImage = latter_image;

      // Upload images to AWS
      if (tournament_image instanceof Blob) {
        try {
          uploadedTournamentImage = await uploadImageOnAWS(
            tournament_image,
            "tournament"
          );
        } catch (error) {
          TOAST_ERROR("Error uploading Tournament image");
        }
      }

      if (latter_image instanceof Blob) {
        try {
          uploadedLatterImage = await uploadImageOnAWS(
            latter_image,
            "tournament"
          );
        } catch (error) {
          TOAST_ERROR("Error uploading letter image");
        }
      }

      // Prepare the request body, sending only validRanges
      const requestBody = {
        tournament_image: uploadedTournamentImage,
        latter_image: uploadedLatterImage,
        tournament_title,
        ar_tournament_title,
        total_used_line,
        image_title,
        ar_image_title,
        wining_point,
        skip_point,
        description,
        ar_description,
        created_id:userData?.id,
        created_by:userData?.role,
        start_date,
        end_date,
        max_participation,
        required_point,
        ranges: newValidRanges,
        is_free: isActive,
      };

      //console.log("final requets is................................................................................", requestBody);

      const { code, message } = await API.insertTournamentApi(requestBody);

      if (code === "1") {
        SWIT_SUCCESS(message);
        navigate(`/manage_tournament`);
        reset();
      }

      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title="Add Tournament"
            header="Tournament"
            subHeader="Add Tournament"
          />
          <div className="card rounded-3">
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                {/* Tournament and Letter Image Fields */}
                <div className="row mb-3">
                  {/* Tournament Image */}
                  <Controller
                    name="tournament_image"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a Tournament image" }}
                    render={({ field }) => (
                      <div className="col-md-6 text-center">
                        {tournamentImageState && (
                          <img
                            src={tournamentImageState}
                            alt="tournament image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="tournament_image"
                          accept="image/*"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setTournamentImage,
                              "tournament_image"
                            )
                          }
                        />
                        {/* Correct the htmlFor attribute to match the input id */}
                        <label
                          htmlFor="tournament_image"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Tournament Image
                        </label>
                        <div className="errorc">
                          {errors.tournament_image?.message}
                        </div>
                      </div>
                    )}
                  />
                  {/* Letter Image */}
                  <Controller
                    name="latter_image"
                    control={control}
                    defaultValue={null}
                    rules={{ required: "Please choose a letter image" }}
                    render={({ field }) => (
                      <div className="col-md-6 text-center">
                        {latterImageState && (
                          <img
                            src={latterImageState}
                            alt="letter image"
                            className="img-fluid img-thumbnail"
                            style={{
                              width: "120px",
                              height: "120px",
                              borderRadius: "10%",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          id="latter_image"
                          accept="image/svg+xml"
                          onChange={(e) =>
                            handleImageChange(
                              e.target.files[0],
                              setLatterImageState,
                              "latter_image"
                            )
                          }
                        />
                        <label
                          htmlFor="latter_image"
                          className="btn btn-outline-info m-1"
                        >
                          Choose Letter Image
                        </label>
                        <div className="errorc">
                          {errors.latter_image?.message}
                        </div>
                      </div>
                    )}
                  />
                </div>

                {/* title Input */}

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="tournament_title" className="form-label">
                      Tournament Title
                    </label>
                    <input
                      type="text"
                      id="tournament_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register("tournament_title", TEXT_WITH_NOT_START_SPACE_VALIDATION("tournament_title"))}aria-invalid={errors.email ? "true" : "false"}/>
                    <div className="errorc">
                      {errors.tournament_title?.message}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="image_title" className="form-label">
                      Image Title
                    </label>
                    <input
                      type="text"
                      id="image_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register("image_title",TEXT_WITH_NOT_START_SPACE_VALIDATION("image_title"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.image_title?.message}</div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="ar_tournament_title" className="form-label">
                      Tournament Title(Arabic)
                    </label>
                    <input
                      type="text"
                      id="ar_tournament_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register("ar_tournament_title", TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_tournament_title"))}aria-invalid={errors.ar_tournament_title ? "true" : "false"}/>
                    <div className="errorc">
                      {errors.tournament_title?.message}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="ar_image_title" className="form-label">
                      Image Title(Arabic)
                    </label>
                    <input
                      type="text"
                      id="ar_image_title"
                      className="form-control"
                      placeholder="Enter Title"
                      {...register("ar_image_title",TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_image_title"))}aria-invalid={errors.ar_image_title ? "true" : "false"}
                    />
                    <div className="errorc">{errors.ar_image_title?.message}</div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/* wining Point Field */}
                  <div className="col-md-3">
                    <label htmlFor="wining_point" className="form-label">
                      Wining Point
                    </label>
                    <input
                      type="text"
                      id="wining_point"
                      className="form-control"
                      placeholder="Enter wining points"
                      {...register("wining_point",NUMBER_VALIDATION("wining points"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.wining_point?.message}</div>
                  </div>

                  {/* skip path Field */}
                  <div className="col-md-3">
                    <label htmlFor="skip_point" className="form-label">
                      Skip Path
                    </label>
                    <input
                      type="text"
                      id="skip_point"
                      className="form-control"
                      placeholder="Enter skip points"
                      {...register("skip_point",  NUMBER_VALIDATION("skip points"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">{errors.skip_point?.message}</div>
                  </div>

                  {/* required Point Field */}
                  <div className="col-md-3">
                    <label htmlFor="required_point" className="form-label">
                      Required Point
                    </label>
                    <input
                      type="text"
                      id="required_point"
                      className="form-control"
                      placeholder="Enter required points"
                      {...register("required_point", NUMBER_VALIDATION("required points"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">
                      {errors.required_point?.message}
                    </div>
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="total_used_line" className="form-label">
                      Total Line
                    </label>
                    <input
                      type="text"
                      id="total_used_line"
                      className="form-control"
                      placeholder="Enter Total line"
                      {...register("total_used_line",  NUMBER_VALIDATION("total line"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">
                      {errors.total_used_line?.message}
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  {/*start date Field */}
                  {/* Start Date Field */}
                  <div className="col-md-4 mb-3">
                    <label htmlFor="start_date" className="form-label fw-bold">
                      Start Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      id="start_date"
                      className={`form-control ${
                        errors.start_date ? "errorc" : ""
                      }`}
                      placeholder="Select start date and time"
                      min={new Date().toISOString().slice(0, 16)} // Set min to current date and time
                      {...register("start_date", {
                        required: "Start date and time is required",
                        onChange: (e) => setStartDate(e.target.value), // Update startDate state
                      })}
                    />
                    {errors.start_date && (
                      <div className="errorc">
                        {errors.start_date.message}
                      </div>
                    )}
                  </div>

                  {/* End Date Field */}
                  <div className="col-md-4 mb-3">
                    <label htmlFor="end_date" className="form-label fw-bold">
                      End Date & Time
                    </label>
                    <input
                      type="datetime-local"
                      id="end_date"
                      className={`form-control ${
                        errors.end_date ? "errorc" : ""
                      }`}
                      placeholder="Select end date and time"
                      min={startDate} // Set min to the selected start date and time
                      {...register("end_date", {
                        required: "End date and time is required",
                        validate: (value) =>
                          value > startDate ||
                          "End date and time must be greater than start date and time",
                      })}
                    />
                    {errors.end_date && (
                      <div className="errorc">
                        {errors.end_date.message}
                      </div>
                    )}
                  </div>

                  {/* maximum Participetion Field */}
                  <div className="col-md-4">
                    <label htmlFor="max_participation" className="form-label">
                      Maximum Participation
                    </label>
                    <input
                      type="text"
                      id="max_participation"
                      className="form-control"
                      placeholder="Entermax participation"
                      {...register("max_participation",NUMBER_VALIDATION("max participation"))}aria-invalid={errors.email ? "true" : "false"}
                    />
                    <div className="errorc">
                      {errors.max_participation?.message}
                    </div>
                  </div>
                </div>

                {/*description */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      id="description"
                      className="form-control"
                      placeholder="Enter description"
                      {...register("description")}
                    />
                    <div className="errorc">{errors.description?.message}</div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="ar_description" className="form-label">
                      Description(Arabic)
                    </label>
                    <textarea
                      id="ar_description"
                      className="form-control"
                      placeholder="Enter description"
                      {...register("ar_description")}
                    />
                    <div className="errorc">{errors.ar_description?.message}</div>
                  </div>
                </div>

                <div className="form-check form-switch mb-3">
                  <label className="form-check-label" htmlFor="is_active">
                    Is This Free
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="is_active"
                    checked={isActive === "true"}
                    onChange={() =>
                      setIsActive(isActive === "true" ? "false" : "true")
                    }
                  />
                </div>

                <h3>Enter Ranges(In Seconds)</h3>
                {ranges.map((range, index) => (
                  <div key={index} className="row mb-3" >
                    <div className="col-md-4">
                      <input
                        type="number"
                        placeholder={`Range ${index + 1} Start Time In Seconds `}
                        className="form-control"
                        value={range.start}
                        onChange={(e) =>
                          handleChange(index, "start", e.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        placeholder={`Range ${index + 1} End Time In Seconds`}
                        className="form-control"
                        value={range.end}
                        onChange={(e) =>
                          handleChange(index, "end", e.target.value)
                        }
                      />
                    </div>

                    <div className="col-md-4">
                      <input
                        type="number"
                        placeholder={`Range ${index + 1} Points`}
                        className="form-control"
                        value={range.points}
                        onChange={(e) =>
                          handleChange(index, "points", e.target.value)
                        }
                      />
                    </div>
                  </div>
                ))}
                {error && <p style={{ color: "red" }}>{error}</p>}

                <div className="mb-0 text-center">
                  <button
                    className="btn btn-soft-primary w-25 buttonColor"
                    type="submit"
                  >
                    <i className="ri-save-fill"></i>{" "}
                    <span className="fw-bold">Add</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
